export default __webpack_public_path__ + "static/media/suspectwhite.1dc4c3b6.svg";